import { render, staticRenderFns } from "./SettlementCommentMessage.vue?vue&type=template&id=1a41d290&scoped=true&"
import script from "./SettlementCommentMessage.vue?vue&type=script&lang=js&"
export * from "./SettlementCommentMessage.vue?vue&type=script&lang=js&"
import style0 from "./SettlementCommentMessage.vue?vue&type=style&index=0&id=1a41d290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41d290",
  null
  
)

export default component.exports